<ion-header>
    <ion-toolbar class="header-color">
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title class="toolbar-title">Reset Password</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content *ngIf="!isTokenValid">
	<p class="reset-password-error-message error-message-text">This URL is no longer valid.</p>
</ion-content>

<ion-content *ngIf="isTokenValid">
	<div class="reset-password">
		<ion-grid>
		      <ion-row>
		        <ion-col>
		        	<div class="reset-password-page">
		 			 	<div class="email-login-section">
			              <div>
			                  <div class="divider-alt ui-or">
			                      <span class="title-page">Enter your new password.</span>
			                  </div>
			              </div>
			              <hr class="thick-border" />
		              	<div class="ion-text-left form-wr">
		                  	<form [formGroup]="resetPasswordForm" (ngSubmit)="submitForm()" novalidate>
		                  	<div formGroupName="matching_passwords">
		                      <ion-item class="inputStyle">
		                          <ion-input
		                                  type="password"
		                                  placeholder="Password"
		                                  formControlName="password"
		                                  required>
		                          </ion-input>
		                      </ion-item>

		                      <ion-item class="inputStyle">
		                          <ion-input
		                                  type="password"
		                                  placeholder="Retype Password"
		                                  formControlName="password2"
		                                  required>
		                          </ion-input>
		                      </ion-item>
		                  </div>
		                  <span *ngIf="this.authService.resetPasswordError"> <p class="reset-password-error-message">{{this.authService.resetPasswordError}}</p></span>
		                      	<div class="warning-box">
									<p>Password must contain at least 8 characters,<br/>
								 		1 capital letter, 1 lower case letter, 1 special character, and 1 number.
								 	</p>
							 	</div>

		           <ng-container *ngIf="this.resetPasswordForm.valid">
                        <ion-button
                                class="login-button update-btn"
                                color="tertiary"
                                expand="block"
                                type="submit"
                                disabled="false"
                        >
                            UPDATE
                        </ion-button>
                    </ng-container>
                    <ng-container *ngIf="!this.resetPasswordForm.valid">
                        <ion-button
                                class="login-button update-btn"
                                color="tertiary"
                                expand="block"
                                type="submit"
                                disabled="true"
                        >
                            UPDATE
                        </ion-button>
                    </ng-container>
		                	</form>
		               	</div>
		           	</div>
		       	</div>
		      </ion-col>
		    </ion-row>
    	</ion-grid>
	</div>
</ion-content>
